<template>
  <div
    class="tw-bg-white tw-text-primary-grey-950 tw-py-2 tw-px-4 tw-flex tw-align-center tw-justify-between tw-ml-[50px] lg:tw-ml-0"
  >
    <div class="tw-flex tw-gap-2 tw-items-center">
      <t-upper-nav-badge />
      <t-breadcrumbs />
    </div>
    <div class="tw-flex tw-gap-4">
      <t-upper-nav-profile-settings />
      <t-upper-nav-display-mode />
      <a
        target="_blank"
        class="tw-block hover:tw-text-primary-grey-700"
        href="https://support.titanhq.com/en/69450-welcome-to-the-titanhq-platform-.html"
        data-test-id="upper-nav-help-button"
        v-tippy="{
          content: $t('tooltip-help'),
          placement: 'bottom',
        }"
        @click="onHelpButtonClick"
      >
        <cb-icon-support />
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import TBreadcrumbs from "@/components/TBreadcrumbs/TBreadcrumbs.vue";
import TUpperNavBadge from "./TUpperNavBadge.vue";
import TUpperNavDisplayMode from "./TUpperNavDisplayMode.vue";
import TUpperNavProfileSettings from "./TUpperNavProfileSettings.vue";
import { trackEvent } from "@/utils/track-event";

const onHelpButtonClick = () => {
  trackEvent({
    category: "Upper navigation",
    action: "help button clicked",
    name: "",
  });
};
</script>
